<template>
    <ReceiptActionButtons
        :paymentFor="paymentFor"
        :emailRecipient="currentEmailRecipient"
        :locationId="locationId"
        :orderId="orderId"
        :paymentId="paymentId"
        :userIsWaiter="userIsWaiter"
        :isPayLater="isPayLater"
        :onSendReceiptSuccess="onSendReceiptSuccess"
        :onPrintSuccess="onPrintSuccess"
        :hidePrintButtonOnEmailInputStarted="true"
    />
</template>

<script setup lang="ts">
    // this component is a wrapper for the ReceiptActionButtons component
    // it is used in the DoneController to pass the emailRecipient as a ref
    // because otherwise the emailRecipient is not reactive in the ReceiptActionButtons component - computed and watch don't work
    import { PaymentFor } from "@/data/model/Enums";
    import { type Ref, computed } from "vue";

    import ReceiptActionButtons from "@/components/payment/ReceiptActionButtons.vue";

    const props = defineProps<{
        paymentFor: PaymentFor;
        emailRecipient: Ref<string | undefined>;
        locationId: string;
        orderId: string | undefined;
        paymentId: string | undefined;
        userIsWaiter: boolean;
        isPayLater: boolean;
        onSendReceiptSuccess: () => void;
        onPrintSuccess: () => void;
    }>();

    const currentEmailRecipient = computed(() => props.emailRecipient.value);
</script>
